
import React from 'react';

const features = [
  'Fast‑track Learning',
  'Real‑world Projects',
  'Interview Practice',
  'Placement Support',
];

export default function Roadmap() {
  return (
    <section
      id="audit"
      className="max-w-7xl mx-auto px-4 py-12 grid lg:grid-cols-2 gap-8 items-start"
    >
      {/* Left: Roadmap overview */}
      <div className="p-6 rounded-2xl border border-slate-200 dark:border-slate-800 shadow-soft reveal">
        <h2 className="text-2xl md:text-3xl font-bold">
          Personalized Roadmap to Guaranteed Job Success
        </h2>

        <ul className="mt-4 space-y-2 text-slate-700 dark:text-slate-300">
          <li>✓ Tailored learning paths aligned to your goals</li>
          <li>✓ Industry‑vetted curriculum &amp; capstone projects</li>
          <li>✓ Dedicated mentors &amp; mock interviews</li>
          <li>✓ Resume, portfolio &amp; referrals through partner network</li>
        </ul>

        <a
          href="#cta"
          className="mt-6 inline-block px-5 py-3 rounded-lg bg-brand-600 text-white hoverd sm:grid-cols-2 gap-4 reveal">
        {features.map((f) => (
          <article key={f} className="feature-card">
            {f}
          </article>
        ))}
        </a>
      </div>
    </section>
  );
}
